import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { ChallengeFocusScoreAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-focus-score.aggregate-root';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';

export class ChallengeFocusScoreAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeFocusScoreAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeFocusScoreAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeFocusScoreAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeFocusScoreAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Number(entity.beforeValue.toFixed(2)),
      afterValue: Number(entity.value.toFixed(2)),
      beforeFormattedValue: String(Math.round(entity.beforeValue)),
      afterFormattedValue: String(Math.round(entity.value)),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Math.round(entity.beforeAverage),
      afterAverage: Math.round(entity.average),
      beforeFormattedAverage: String(Math.round(entity.beforeAverage)),
      afterFormattedAverage: String(Math.round(entity.average)),
    };
  }
}
